var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClearbitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4v1.96c-.007.67-.084.928-.223 1.187a1.514 1.514 0 01-.63.63l-.036.02c-.26.132-.538.203-1.248.203H4V4h4z",
    fill: "url(#clearbit-icon_svg__clearbit0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.147.223c.272.145.485.358.63.63l.02.036c.132.26.203.538.203 1.248V4H4V0h1.863c.743 0 1.013.077 1.284.223z",
    fill: "url(#clearbit-icon_svg__clearbit1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0v8H2.04c-.67-.007-.928-.084-1.187-.223a1.514 1.514 0 01-.63-.63l-.02-.036C.072 6.851 0 6.573 0 5.863V2.137C0 1.394.077 1.124.223.853.368.58.58.368.853.223l.036-.02C1.149.072 1.427 0 2.137 0H4z",
    fill: "url(#clearbit-icon_svg__clearbit2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clearbit-icon_svg__clearbit0_linear",
    x1: 6,
    y1: 4,
    x2: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF2FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBF1FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clearbit-icon_svg__clearbit1_linear",
    x1: 4,
    y1: 0,
    x2: 6,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B5FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "clearbit-icon_svg__clearbit2_linear",
    x1: 1.5,
    y1: 0,
    x2: 4.9,
    y2: 6.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CA7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148CFC"
  })))));
}

export default SvgClearbitIcon;